import _, { remove } from 'lodash'
import { isImmutable, Map } from 'immutable'
import { IMap, IAddress, IQuickAddress, IGenericAddress } from '../index'
// import { IQuickAddress } from '../types'
import { removeUnknownString } from './stringutil'
import CONS from '../config/constants'

type IConvertAddressToInlineAddressOptions = {
  replacedName?: string
  withoutName?: boolean
}

// Sample:
// อัจฉริยา เจริญศักดิ์ 66848744155 176/79 หมู่บ้านรัตนาวลัยหลักสี่ ประชาอุทิศ17 ถนน ประชาอุทิศ ตำบลหมากแข้ง อำเภอเมืองอุดรธานี จังหวัดอุดรธานี 41000 0-1212-15435-12-3
// ปารนีย์ อนันต์เศรษฐศิริ 12/209-210 ซ.13 ถ.ลพบุรีราเมศวร์ ต.คลองแห อ.หาดใหญ่ จ.สงขลา 90110

// บริษัท ดรีมอินสไปร์ จำกัด (สำนักงานใหญ่)
// 222/172 หมู่บ้านเออร์เบิน สาทร ถนนราชพฤกษ์ แขวงบางจาก เขตภาษีเจริญ กทม. 10160
// เลขประจำตัวผู้เสียภาษี
// 0105567199669

// บริษัท ดรีมอินสไปร์ จำกัด (สำนักงานใหญ่) 222/172 หมู่บ้านเออร์เบิน สาทร ถนนราชพฤกษ์ แขวงบางจาก เขตภาษีเจริญ กทม. 10160
// เลขประจำตัวผู้เสียภาษี 0105567199669
// 0952584542

// บริษัท ดรีมอินสไปร์ จำกัด (สำนักงานใหญ่) 222/172 หมู่บ้านเออร์เบิน สาทร ถนนราชพฤกษ์แขวงบางจาก เขตภาษีเจริญ กทม. 10160 เลขประจำตัวผู้เสียภาษี 0105567199669 0952584542

export function convertInlineAddressToQuickAddress(text: string): IQuickAddress {
  // console.log('addressParser.convertInlineAddressToQuickAddress called with text:', text)
  const quickAddress: IQuickAddress | any = {
    id: null,
    address1: null,
    address2: null,
    sub_district: null,
    district: null,
    province: null,
    postal_code: null,
    telephone: null,
  }

  if (!text || text.trim().length === 0) {
    return quickAddress
  }
  let txtAddress = _.clone(text)
  // let quickAddress:QuickAddress = <QuickAddress>{}

  quickAddress.address3 = ''

  const regZipcode = /[1-9][0-9]{3}0/g
  // console.log('txtAddress before processing => ', txtAddress)
  let splitedAddresses = txtAddress.split('\n')
  // console.log('splitedAddresses', splitedAddresses)
  if (!splitedAddresses || splitedAddresses.length === 0) {
    return quickAddress
  }
  let zip_code = ''
  let regInline
  let regX
  let breakZipcode = false
  let cutAline = false
  let isStart = false
  let isEnd = false
  let betweenLineIndex = 0
  for (let i = 0; i < splitedAddresses.length; i++) {
    // บรรทัดที่ i
    // let aLine = splitedAddresses[i].trim()
    const aLine = splitedAddresses[i]
    regInline = aLine.match(regZipcode)
    // log(regInline)
    if (!_.isNull(regInline)) {
      // ถ้าบรรทัดที่ i ไม่มีคำที่ต้องการ ก็ไม่ต้องทำอะไรต่อ
      for (let ii = 0; ii < regInline.length; ii++) {
        // คำที่เจอในบรรทัดที่ i ลำดับที่ ii
        if (aLine.length === 5) {
          // คำที่เจอตรงตามเงื่อนไขพอดี
          cutAline = true
          quickAddress.postal_code = aLine
          txtAddress = replaceZipcode(splitedAddresses, i, cutAline, isStart, isEnd, betweenLineIndex)
          // txtAddress = txtAddress.replace(quickAddress.postal_code, '')
          breakZipcode = true
          break
        } else {
          let rawDataZipCode
          const start = aLine.indexOf(regInline[ii])
          let end = false
          const valLineOfEnd = aLine.length - 5
          if (valLineOfEnd === start) {
            end = true
          }
          if (start === 0) {
            // คำที่เจอ เจอเป็นคำแรกของบรรทัดที่ i
            isStart = true
            regX = /[1-9][0-9]{3}0[^\d]/g
            rawDataZipCode = aLine.match(regX)
            if (_.isArray(rawDataZipCode) && rawDataZipCode.length > 0) {
              // ถ้าข้างหลังคำที่เจอไม่ใช่ตัวเลข ให้ดำเนินการต่อไป
              zip_code = rawDataZipCode[0].substring(0, 5)
              quickAddress.postal_code = zip_code
              txtAddress = replaceZipcode(splitedAddresses, i, cutAline, isStart, isEnd, betweenLineIndex)
              // txtAddress = txtAddress.replace(zip_code, '')
              breakZipcode = true
              break
            }
          } else if (end) {
            // ถ้าคำที่เจอ เจอเป็นคำสุดท้ายของบรรทัดที่ i
            isEnd = true
            regX = /[^\d][1-9][0-9]{3}0/g
            rawDataZipCode = aLine.match(regX)
            if (_.isArray(rawDataZipCode) && rawDataZipCode.length > 0) {
              zip_code = rawDataZipCode[0].substring(1, 6)
              quickAddress.postal_code = zip_code
              txtAddress = replaceZipcode(splitedAddresses, i, cutAline, isStart, isEnd, betweenLineIndex)
              // txtAddress = txtAddress.replace(zip_code, '')
              breakZipcode = true
              break
            }
          } else {
            regX = /[^\d][1-9][0-9]{3}0[^\d]/g
            rawDataZipCode = aLine.match(regX)
            if (!_.isNil(rawDataZipCode)) {
              const matchResult = regX.exec(aLine)
              betweenLineIndex = matchResult.index + 1
              if (_.isArray(rawDataZipCode) && rawDataZipCode.length > 0) {
                zip_code = rawDataZipCode[0].substring(1, 6)
                quickAddress.postal_code = zip_code
                txtAddress = replaceZipcode(splitedAddresses, i, cutAline, isStart, isEnd, betweenLineIndex)
                // txtAddress = txtAddress.replace(zip_code, '')
                breakZipcode = true
                break
              }
            }
          }
        }
      }
    }
    if (breakZipcode) {
      break
    }
  }
  // console.log('splitedAddresses', splitedAddresses)
  // console.log('splitedAddresses.length', splitedAddresses.length)
  // console.log('extractLegalEntityID called with quickAddress => ', quickAddress)
  // console.log('before extractLegalEntityID quickAddress.address1 => ', quickAddress.address1)
  txtAddress = extractLegalEntityID(txtAddress, quickAddress)
  // extractLegalEntityID(quickAddress, 'address3')

  // let postal_code = txtAddress.match(regZipcode) || []
  // // log('BOV4 ' + postal_code)
  // if (postal_code.length > 0) {
  //   let postalCode = postal_code[0].trim()
  //   if (postalCode.length === 6) {
  //     postalCode = postalCode.substring(1, 6)
  //   }
  //   quickAddress['postal_code'] = postalCode
  //   // quickAddress['postal_code'] = postal_code[0]
  //   txtAddress = txtAddress.replace(quickAddress.postal_code, '')
  // }

  // Must split each line before doing matching as the regPhones won't work properly if there is new line char (\n)
  // regPhones แบบเก่า /\(?\+?[0-9]*\)?(\-{0,2}\s{0,1}[0-9]){7,}\)?/g,
  const regPhones = [
    /\+?[0-9]{3}[-\s]{0,1}[0-9]{3}[-\s]{0,1}[0-9]{4,7}/g,
    // The above regex is tested against the following samples:
    // 096 978 4644
    // 096-978 4644
    // 096 9784644
    // (0851247452)
    // (085 124-7452)
    // 66848744155
    // +66848744155

    /\(?\+?[0-9]{0,2}\)?[0-9_]{0,3}\s{0,1}?\(?\+?[0-9_]*\)?(\-{0,2}[0-9_]){7,}\)?/g, // (+66) 837031118, +662 837031118, (0851247452), (085-124-7452), 085-124-7452, (085)1234567, 085_8974568
    // /\(?\+?[0-9]{0,2}\)?[0-9]{0,3}\s{0,1}?\(?\+?[0-9]*\)?(\-{0,2}[0-9]){7,}\)?/g, // (+66) 837031118, +662 837031118, (0851247452), (085-124-7452), 085-124-7452, (085)1234567
    // /\(?\+?[0-9]*\)?(\-{0,2}[\s\S]{0,2}[0-9](?!.*\n)){7,}\)?/g,
    // อัจฉริยา เจริญศักดิ์ 66848744155 176/79 หมู่บ้านรัตนาวลัยหลักสี่ ประชาอุทิศ17 ถนน ประชาอุทิศ เขตดอนเมือง จังหวัดกรุงเทพมหานคร 10210
  ]
  // สำหรับเช็คเลขเรียง 10 ตัว
  // 0[0-9]{0,2}[0-9]{7}

  let telephone
  let isTelFound = false
  for (let idx = 0; idx < regPhones.length; idx++) {
    // loop for each pattern
    if (isTelFound) {
      break
    }
    // console.log('BOV2 => ', telephone)
    // for (let i = 0; i < splitedAddresses.length; i++) {
    //   let aLine = splitedAddresses[i].trim()
    //   aLine = removeUnknownString(aLine)
    txtAddress = removeUnknownString(txtAddress)

    telephone = txtAddress.match(regPhones[idx])
    // console.log('BOV3 ' + aLine)
    if (telephone && telephone.length > 0 && telephone[0].length < 13) {
      // console.log('telephone Matched found!! => ', telephone)
      // log(telephone)

      let tel = telephone[0].trim()

      // console.log('BOV4 tel' + tel)
      // console.log('txtAddress before removing telephone => ', txtAddress)
      // Remove the telephone from the address
      txtAddress = txtAddress.replace(tel, '')
      // console.log('txtAddress after removing telephone => ', txtAddress)

      // Then clean up the whole address
      txtAddress = txtAddress.replace('โทร.', '')
      txtAddress = txtAddress.replace('โทร:', '')
      txtAddress = txtAddress.replace('โทร', '')
      txtAddress = txtAddress.replace('โทร ', '')
      txtAddress = txtAddress.replace('โทรศัพท์:', '')
      txtAddress = txtAddress.replace('โทรศัพท์', '')
      txtAddress = txtAddress.replace('(+66)', '')
      txtAddress = txtAddress.replace('tel.', '')
      txtAddress = txtAddress.replace('tel: ', '')
      // log('txtAddress1: ' + txtAddress)
      txtAddress = txtAddress.replace('tel ', '')
      // log('txtAddress2: ' + txtAddress)
      // Trim space หน้าหลัง
      txtAddress = txtAddress.trim()

      // Now clean up the phone number
      // Remove ( ) - โทร โทรศัพท์ (+66)
      // Remove start with #
      // Remove 66 if starts with 660
      // Test with
      /*
          เก่ง
          142 ถนนกาญาจนา 10160
          โทร: (+66)087-897-8977ต่อ5555

          เก่ง
          142 ถนนกาญาจนา 10160
          โทร: 66087-897-8977ต่อ5555

          093-021 4111
          080 665 6585
        */
      tel = tel.replace(/\s/g, '')
      tel = tel.replace(/[()-]/g, '') // remove all occurances of ( ) -
      tel = tel.replace('(+66)', '')
      tel = tel.trim()
      // assign the telephone number to the quickAddress object
      quickAddress.telephone = tel

      // quickAddress.telephone = '0123456789'
      isTelFound = true
      // break
      // }
    }
  }

  splitedAddresses = txtAddress.trim().split(/\r\n|\n\r|\r|\n/)
  // console.log('splitedAddresses after txtAddress.split', splitedAddresses)

  // split the first line if it contains the company name (มีคำว่า สำนักงานใหญ่ หรือ จำกัด) and address
  const splitArray = splitedAddresses[0].split(' ')
  // find the position of '(สำนักงานใหญ่)' or 'สำนักงานใหญ่' or '(สำนักงานใหญ่)'
  const indexOfHeadquarter = splitArray.findIndex((item) => item.includes('สำนักงานใหญ่') || item.includes('(สำนักงานใหญ่)'))
  // console.log('indexOfHeadquarter', indexOfHeadquarter)
  if (indexOfHeadquarter !== -1) {
    // If found, remove the item from the array
    const theIndex = indexOfHeadquarter + 1
    // append the first two parts of the address to the splitedAddresses, then append the rest
    splitedAddresses = [splitArray.slice(0, theIndex).join(' '), splitArray.slice(theIndex).join(' '), ...splitedAddresses.slice(1)]
  } else {
    // handle case: บริษัท ดรีมอินสไปร์เดอร์ จำกัด 222/172 หมู่บ้านเออร์เบิน สาทร ถนนราชพฤกษ์แขวงบางจาก เขตภาษีเจริญ กทม. 10160 เลขประจำตัวผู้เสียภาษี 0105567199669 0952584542
    const indexOfLimited = splitArray.findIndex((item) => item.includes('จำกัด'))
    // console.log('indexOfLimited', indexOfLimited)
    if (indexOfLimited !== -1) {
      const theIndex = indexOfLimited + 1
      // append the first two parts of the address to the splitedAddresses, then append the rest if any
      splitedAddresses = [splitArray.slice(0, theIndex).join(' '), splitArray.slice(theIndex).join(' '), ...splitedAddresses.slice(1)]
    } else {
      // Default case: no จำกัด or สำนักงานใหญ่
      // Just assume it's a person name Combine the first two elements and the rest
      splitedAddresses = [splitArray.slice(0, 2).join(' '), splitArray.slice(2).join(' '), ...splitedAddresses.slice(1)]
    }
  }

  // ensure that it matches 5 to 6 char that the last 5 are digit and it's not part of long number like phone#
  // const regZipcode = /[0-9][0-9-]{4,}/g // this one will catch the wrong one i.e. 12/209-210 ซ.13

  // if (isTelFound) {
  // reset the array as txtAddress has been changed
  // splitedAddresses = removeUnknownString(txtAddress.trim()).split('\n')

  // Handle the case where the pasted text is just one line by spliting into two items i.e.
  // ร.ต.อ.หญิงจิราภรณ์ บัวทอง 270 หมู่2 บ้านโพธิ์ไทร ต.โพธิ์ไทร อ.พิบูลมังสาหาร จ.อุบลราชธานี 34190
  // or
  // ภาวิณี ศรีวิเศษ รพ.สต.โกรกกุลา ต.ตาเนิน อ.เนินสง่า จ.ชัยภูมิ 36130 โทร0922791582
  // In short, converting ["ภาวิณี ศรีวิเศษ รพ.สต.โกรกกุลา ต.ตาเนิน อ.เนินสง่า จ.ชัยภูมิ 36130 โทร0922791582"]
  // to ["ภาวิณี ศรีวิเศษ", "รพ.สต.โกรกกุลา ต.ตาเนิน อ.เนินสง่า จ.ชัยภูมิ 36130 โทร0922791582"]
  // console.log('splitedAddresses.len check', splitedAddresses)
  /*
  if (splitedAddresses.length === 1) {
    // one liner
    // Split the string into an array based on spaces
    const splitArray = splitedAddresses[0].split(' ')
    console.log('splitedAddresses.length === 1', splitedAddresses)

    // handle case: บริษัท ดรีมอินสไปร์ จำกัด (สำนักงานใหญ่) 222/172 หมู่บ้านเออร์เบิน สาทร ถนนราชพฤกษ์แขวงบางจาก เขตภาษีเจริญ กทม. 10160 เลขประจำตัวผู้เสียภาษี 0105567199669 0952584542

    // find the position of '(สำนักงานใหญ่)' or 'สำนักงานใหญ่' or '(สำนักงานใหญ่)'
    const indexOfHeadquarter = splitArray.findIndex((item) => item.includes('สำนักงานใหญ่') || item.includes('(สำนักงานใหญ่)'))
    console.log('indexOfHeadquarter', indexOfHeadquarter)
    if (indexOfHeadquarter !== -1) {
      // If found, remove the item from the array
      const theIndex = indexOfHeadquarter + 1
      splitedAddresses = [splitArray.slice(0, theIndex).join(' '), splitArray.slice(theIndex).join(' ')]
    } else {
      // handle case: บริษัท ดรีมอินสไปร์เดอร์ จำกัด 222/172 หมู่บ้านเออร์เบิน สาทร ถนนราชพฤกษ์แขวงบางจาก เขตภาษีเจริญ กทม. 10160 เลขประจำตัวผู้เสียภาษี 0105567199669 0952584542
      const indexOfLimited = splitArray.findIndex((item) => item.includes('จำกัด'))
      console.log('indexOfLimited', indexOfLimited)
      if (indexOfLimited !== -1) {
        const theIndex = indexOfLimited + 1
        splitedAddresses = [splitArray.slice(0, theIndex).join(' '), splitArray.slice(theIndex).join(' ')]
      } else {
        // Default case: no จำกัด or สำนักงานใหญ่
        // Just assume it's a person name Combine the first two elements and the rest
        splitedAddresses = [splitArray.slice(0, 2).join(' '), splitArray.slice(2).join(' ')]
      }
    }

    // console.log('splitedAddresses', splitedAddresses)
  }
*/
  // console.log('splitedAddresses after split', splitedAddresses)
  // สับ empty string ทิ้งไป
  // แก้ไขปัญหา https://effily.atlassian.net/browse/XSELLY-725 (case 1, 2, 3)
  for (let i = 0; i < splitedAddresses.length; i++) {
    splitedAddresses[i] = splitedAddresses[i].trim()
    if (splitedAddresses[i] === '') {
      splitedAddresses.splice(i, 1)
    }
  }
  // }

  // Handle / and - in the address
  //   ปารนีย์ อนันต์เศรษฐศิริ
  //   12/209-210 ซ.13 ถ.ลพบุรีราเมศวร์ ต.คลองแห อ.หาดใหญ่ จ.สงขลา 90110
  //   โทร
  //   0831309933

  // log('BOV5 ' + splitedAddresses)
  // console.log('splitedAddresses', splitedAddresses)
  if (splitedAddresses) {
    if (splitedAddresses.length === 1 && splitedAddresses[0].trim().length > 0) {
      // single line (name + address are on the same line)
      // Get the name assuming that it comes before any digit
      const regADigit = /\d/g
      const theLine = splitedAddresses[0].trim()
      const singleLineSplitedAddr = theLine.match(regADigit)
      // console.log('singleLineSplitedAddr ', singleLineSplitedAddr)
      if (singleLineSplitedAddr && singleLineSplitedAddr.length > 0) {
        // log('singleLineSplitedAddr')
        // log(singleLineSplitedAddr)
        const firstDigit = singleLineSplitedAddr[0]
        const firstDigitPos = theLine.indexOf(firstDigit)
        quickAddress.name = theLine.substring(0, firstDigitPos).trim()
        quickAddress.address3 = theLine.substring(firstDigitPos, theLine.length).trim()
      }
    } else if (splitedAddresses.length > 1) {
      const regADigit = /\d/g
      const theLine = splitedAddresses[0].trim()
      const singleLineSplitedAddr = theLine.match(regADigit)
      // console.log('singleLineSplitedAddr ', singleLineSplitedAddr)

      // console.log('firstDigitPos', firstDigitPos)

      /*
      Case ทดสอบ ที่ 1) มี เลขอยู่ข้างหน้า ลูกค้าใช้ในการรันเลขส่วนตัว
      6.COD200฿แม่นม4ห่อ ศศิวิมล บุญชัย
      PRESENT CONDOMINIUM EKACHAI 32  ที่55/257 ชั้น3 ตึกB ถ.เอกชัย แขวงบางขุนเทียน เขตจอมทอง กรุงเทพฯ    (k.บลู
      10150
      โทร. 0842750758)

      Case ทดสอบ ที่ 2) แบบ happy path
      กนกวรรณ เศรษฐพงศ์วนิช
      1345 ถนนราชดำเนิน เขตดอนเมือง
      กทม 10180
      0971627389
      */
      if (!_.isNil(singleLineSplitedAddr)) {
        // const firstDigit = singleLineSplitedAddr[0]
        // const firstDigitPos = theLine.indexOf(firstDigit)
        // console.log('the line', theLine)

        // Set the whole first line as name
        quickAddress.name = theLine

        // quickAddress.name = theLine.substring(0, firstDigitPos).trim()
        // quickAddress.address3 = theLine.substring(firstDigitPos, theLine.length).trim() + ' '
      } else {
        quickAddress.name = splitedAddresses[0].trim()
      }
      // console.log('quickAddress.name', quickAddress.name)
      // multiline
      // Starting from 2nd line compute the address
      for (let j = 1; j < splitedAddresses.length; j++) {
        const tmp = splitedAddresses[j].trim()
        if (tmp && tmp.length > 0) {
          if (j > 1) {
            quickAddress.address3 += '\n'
          }
          quickAddress.address3 += tmp
        }
      }
    }
  }

  // Trim address3
  if (_.isString(quickAddress.address3) && quickAddress.address3.length > 0) {
    quickAddress.address3 = removeUnknownString(quickAddress.address3.trim())
  }

  // Remove wired bracket
  if (
    quickAddress.telephone &&
    quickAddress.telephone.length > 2 &&
    _.isString(quickAddress.address3) &&
    quickAddress.address3.length > 2
  ) {
    const lastTwoOfAddress2 = quickAddress.address3.slice(-2)
    const isContainWiredฺBracket = lastTwoOfAddress2 === '()'
    if (isContainWiredฺBracket) {
      quickAddress.address3 = quickAddress.address3.slice(0, -2)
    }
  }

  /**
   * regex for legal entity id:
   * ^\d{1}-\d{4}-\d{5}-\d{1,2}-\d{1,3}$
   * ^\d{1,}-\d{5}-\d{3}-\d{3}-\d{2}$
   * ^\d{1,}-\d{5}-\d{9,}$
   * ^\d{1}-\d{5}-\d{6}-\d{3}$
   * ^\d{13}$
คุณประเสริฐ ผลิตภัณฑ์การชั่ง
456 ถนนสาทรใต้ แขวงทุ่งมหาเมฆ
เขตสาทร กรุงเทพ 10120 (089-1234756)
0-1212-15435-12-3
  */
  // console.log('quickAddress before legal check', quickAddress)
  /*
  const regLegalEntityIdArray = [
    // 0-1212-15435-12-3
    /\d{1}-\d{4}-\d{5}-\d{1,2}-\d{1,3}/g,
    // 0-12316-513-513-55
    /\d{1,}-\d{5}-\d{3}-\d{3}-\d{2}/g,
    // 0-12316-513513515
    /\d{1,}-\d{5}-\d{9,}/g,
    // 0-12316-513513-515
    /\d{1}-\d{5}-\d{6}-\d{3}/g,
    // 0121215435123
    /\d{13}/g,

    // sample:
    // อัจฉริยา เจริญศักดิ์ 66848744155 176/79 หมู่บ้านรัตนาวลัยหลักสี่ ประชาอุทิศ17 ถนน ประชาอุทิศ เขตดอนเมือง จังหวัดกรุงเทพมหานคร 10210 0-1212-15435-12-3
  ]

  // sample: Legal Entity
  // บริษัท ดรีมอินสไปร์ จำกัด (สำนักงานใหญ่)
  // 222/172 หมู่บ้านเออร์เบิน สาทร ถนนราชพฤกษ์ แขวงบางจาก เขตภาษีเจริญ กทม. 10160
  // เลขประจำตัวผู้เสียภาษี
  // 0105567199669

  const regLegalEntityIdTenDigitArray = [
    // 3-0332-9304-3
    /\d{1}-\d{4}-\d{4}-\d{1}/g,
    // 3033293043
    /\d{10}/g,
  ]

  const addressToCheckText = quickAddress.address3
  let legelEntityId: string = null
  let legelEntityIdFound = false
  let legalEntityIdMatchTenDigit = false

  for (let i = 0; i < regLegalEntityIdArray.length; i++) {
    const regUse = regLegalEntityIdArray[i]
    const reg = new RegExp(regUse)
    if (reg.test(addressToCheckText)) {
      legelEntityIdFound = true
      const checkedArray = addressToCheckText.match(regUse)
      // console.log('regLegalEntityId regUse', regUse)
      // console.log('regLegalEntityId checkedArray', checkedArray)
      if (checkedArray && checkedArray.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        legelEntityId = checkedArray[0]
        break
      }
    }
  }

  if (!legelEntityIdFound) {
    for (let i = 0; i < regLegalEntityIdTenDigitArray.length; i++) {
      const regUse = regLegalEntityIdTenDigitArray[i]
      const reg = new RegExp(regUse)
      if (reg.test(addressToCheckText)) {
        legelEntityIdFound = true
        const checkedArray = addressToCheckText.match(regUse)
        if (checkedArray && checkedArray.length > 0) {
          // eslint-disable-next-line prefer-destructuring
          legelEntityId = checkedArray[0]
          legalEntityIdMatchTenDigit = true
          break
        }
      }
    }
  }
  // console.log('legelEntityIdFound', legelEntityIdFound)
  // console.log('legelEntityId', legelEntityId)
  if (legelEntityIdFound && legelEntityId) {
    quickAddress.legal_entity_id = legelEntityId.replace(/-/g, '')
    const { name: nm, address3: a3 } = quickAddress
    if (
      legalEntityIdMatchTenDigit ||
      nm.includes('บริษัท') ||
      nm.includes('บจก') ||
      nm.includes('ห้างหุ้น') ||
      nm.includes('จำกัด') ||
      nm.includes('มหาชน') ||
      a3.includes('บริษัท') ||
      a3.includes('บจก') ||
      a3.includes('ห้างหุ้น') ||
      a3.includes('จำกัด') ||
      a3.includes('มหาชน')
    ) {
      quickAddress.legal_entity_type = 2
    } else {
      quickAddress.legal_entity_type = 1
    }

    if (quickAddress?.legal_entity_type === 1) {
      quickAddress.legal_entity_type_more_id = 11
    }
    if (quickAddress?.legal_entity_type === 2) {
      if (nm.includes('บริษัท') || nm.includes('บจก')) {
        quickAddress.legal_entity_type_more_id = 11
      } else if (nm.includes('ห้างหุ้นส่วน') || nm.includes('หจก')) {
        quickAddress.legal_entity_type_more_id = 13
      } else if (nm.includes('มหาชน')) {
        quickAddress.legal_entity_type_more_id = 12
      } else {
        quickAddress.legal_entity_type_more_id = 19
      }
    }

    quickAddress.address3 = quickAddress.address3.replace(`${CONS.ADDRESS_LEGAL_ENTITY_LABELS[1]}:`, '')
    quickAddress.address3 = quickAddress.address3.replace(`${CONS.ADDRESS_LEGAL_ENTITY_LABELS[2]}:`, '')
    quickAddress.address3 = quickAddress.address3.replace(`เลขบัตรประชาชน:`, '')
    quickAddress.address3 = quickAddress.address3.replace(`บัตรประชาชน:`, '')
    quickAddress.address3 = quickAddress.address3.replace(`เลขผู้เสียภาษี:`, '')
    quickAddress.address3 = quickAddress.address3.replace(`เลขบัตร:`, '')
    quickAddress.address3 = quickAddress.address3.replace(CONS.ADDRESS_LEGAL_ENTITY_LABELS[1], '')
    quickAddress.address3 = quickAddress.address3.replace(CONS.ADDRESS_LEGAL_ENTITY_LABELS[2], '')
    quickAddress.address3 = quickAddress.address3.replace('เลขบัตรประชาชน', '')
    quickAddress.address3 = quickAddress.address3.replace('บัตรประชาชน', '')
    quickAddress.address3 = quickAddress.address3.replace('เลขผู้เสียภาษี', '')
    quickAddress.address3 = quickAddress.address3.replace('เลขบัตร', '')
    quickAddress.address3 = quickAddress.address3.replace(/\n/g, '')
    quickAddress.address3 = removeUnknownString(quickAddress.address3.replace(legelEntityId, '').trim())
  }
  // console.log('quickAddress after legal check', quickAddress)
*/
  // console.log('quickAddress before email check', quickAddress)
  const regEmail = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g
  let email: string = null
  let emailFound = false

  const addressToCheckText = quickAddress.address3
  if (regEmail.test(addressToCheckText)) {
    emailFound = true
    const checkedArray = addressToCheckText.match(regEmail)
    // console.log('email regEmail', regEmail)
    // console.log('email checkedArray', checkedArray)
    if (checkedArray && checkedArray.length > 0) {
      // eslint-disable-next-line prefer-destructuring
      email = checkedArray[0]
    }
  }

  if (emailFound && email) {
    quickAddress.email = email
    quickAddress.address3 = quickAddress.address3.replace('อีเมลล์:', '')
    quickAddress.address3 = quickAddress.address3.replace('อีเมล์:', '')
    quickAddress.address3 = quickAddress.address3.replace('อีเมล:', '')
    quickAddress.address3 = quickAddress.address3.replace('email:', '')
    quickAddress.address3 = quickAddress.address3.replace('Email:', '')
    quickAddress.address3 = quickAddress.address3.replace('EMail:', '')
    quickAddress.address3 = quickAddress.address3.replace('E-Mail:', '')
    quickAddress.address3 = quickAddress.address3.replace('E-mail:', '')
    quickAddress.address3 = quickAddress.address3.replace('e-mail:', '')
    quickAddress.address3 = quickAddress.address3.replace('อีเมลล์', '')
    quickAddress.address3 = quickAddress.address3.replace('อีเมล์', '')
    quickAddress.address3 = quickAddress.address3.replace('อีเมล', '')
    quickAddress.address3 = quickAddress.address3.replace('email', '')
    quickAddress.address3 = quickAddress.address3.replace('Email', '')
    quickAddress.address3 = quickAddress.address3.replace('EMail', '')
    quickAddress.address3 = quickAddress.address3.replace('E-Mail', '')
    quickAddress.address3 = quickAddress.address3.replace('E-mail', '')
    quickAddress.address3 = quickAddress.address3.replace('e-mail', '')
    quickAddress.address3 = quickAddress.address3.replace(/\n/g, '')
    quickAddress.address3 = removeUnknownString(quickAddress.address3.replace(email, '').trim())
  }
  // console.log('quickAddress after email check', quickAddress)

  const regDistrict = /(?:อ\.|อำเภอ|เขต)\S+/
  const matchDistrict = quickAddress.address3.match(regDistrict)
  // console.log('matchDistrict3', matchDistrict3)
  if (matchDistrict) {
    const extractedWord = matchDistrict[0]
    quickAddress.district = extractedWord
    // quickAddress.district = removeUnknownString(quickAddress.district.replace('อ.', '').trim())
    quickAddress.address3 = removeUnknownString(quickAddress.address3.replace(extractedWord, '').trim())
  }

  // sample:
  // ปราชญ์
  // บ้านเลขที่ 95 ซอยเฉลิมพระเกียรติ4 แขวงหนองบอน เขตประเวศ กทม 10250 0895599697
  const regSubDistrict = /(?:ต\.|ตำบล|แขวง)\S+(?: ?[0-9]+)?/
  const matchSubDistrict3 = quickAddress.address3.match(regSubDistrict)
  if (matchSubDistrict3) {
    const extractedWord = matchSubDistrict3[0]
    quickAddress.sub_district = extractedWord
    quickAddress.address3 = removeUnknownString(quickAddress.address3.replace(extractedWord, '').trim())
  }

  // console.log('quickAddress.address3', quickAddress.address3)
  const regProvice = /(?:จ\.|จังหวัด)\S+/
  const matchProvice = quickAddress.address3.match(regProvice)
  // console.log('matchProvice', matchProvice)
  if (matchProvice) {
    const extractedWord = matchProvice[0]
    quickAddress.province = extractedWord
    quickAddress.address3 = removeUnknownString(quickAddress.address3.replace(extractedWord, '').trim())
  } else {
    const matchedProvince = CONS.PROVINCES_FOR_ADDRESS_CHECK.find((province) => quickAddress.address3.includes(province))
    // console.log('matchedProvince1', matchedProvince)
    if (!_.isNil(matchedProvince) && matchedProvince.length > 0) {
      quickAddress.address3 = removeUnknownString(quickAddress.address3.replace(matchedProvince, '').trim())
      quickAddress.province = matchedProvince
    }
  }
  if (quickAddress.province && quickAddress.province.length > 0) {
    quickAddress.province = quickAddress.province.replace('จ.', '').trim()
    quickAddress.province = quickAddress.province.replace('จังหวัด', '').trim()
  }

  // console.log('Returing quickAddress', quickAddress)
  return quickAddress
}

export function convertNormalAddressToQuickAddress(addr: IAddress | IMap<IAddress>): IQuickAddress {
  const newAddr: IQuickAddress | any = {
    id: null,
    name: '',
    address1: null,
    address2: null,
    address3: '',
    district: null,
    sub_district: null,
    province: null,
    postal_code: '',
    telephone: '',
    legal_entity_id: null,
    legal_entity_type: 0,
    branch_type: null,
    branch_number: null,
  }

  if (_.isNil(addr)) {
    return newAddr
  }

  let addrObj: IAddress = addr as IAddress
  if (isImmutable(addr)) {
    addrObj = addr.toJS()
  }

  newAddr.name = addrObj.name || ''
  // @ts-ignore
  newAddr.address3 = addrObj.address3 || ''
  // @ts-ignore
  if (addrObj.address1 && (addrObj.address3 === null || addrObj.address3 === '')) {
    const address1 = addrObj.address1 || null
    const address2 = addrObj.address2 || null
    // const sub_district = addrObj.sub_district || null
    // const district = addrObj.district || null
    // const province = addrObj.province || null
    let txtFullAddress = ''
    txtFullAddress = address1
    txtFullAddress = address2 ? `${txtFullAddress} ${address2}` : txtFullAddress
    // txtFullAddress = sub_district ? `${txtFullAddress} ${sub_district}` : txtFullAddress
    // txtFullAddress = district ? `${txtFullAddress} ${district}` : txtFullAddress
    // txtFullAddress = province ? `${txtFullAddress} ${province}` : txtFullAddress
    newAddr.address3 = txtFullAddress
  }
  newAddr.sub_district = addrObj.sub_district || ''
  newAddr.district = addrObj.district || ''
  newAddr.province = addrObj.province || ''
  newAddr.postal_code = addrObj.postal_code || ''
  newAddr.postal_code = newAddr.postal_code.toString()
  newAddr.telephone = addrObj.telephone || ''
  newAddr.email = addrObj.email || ''
  newAddr.legal_entity_type = addrObj.legal_entity_type || 0
  newAddr.legal_entity_id = addrObj.legal_entity_id || ''
  newAddr.branch_type = addrObj.branch_type || null
  newAddr.branch_number = addrObj.branch_number || null

  return newAddr
}

export function replaceZipcode(splitedAddresses, lineNumber, cutAline, isStart, isEnd, betweenLineIndex) {
  const splitedAddressesLength = splitedAddresses.length
  let newAddress = ''
  for (let i = 0; i < splitedAddressesLength; i++) {
    if (lineNumber === i) {
      if (isStart) {
        splitedAddresses[i] = splitedAddresses[i].substring(5, splitedAddresses[i].length)
        newAddress = `${newAddress + splitedAddresses[i]}\n`
      } else if (isEnd) {
        splitedAddresses[i] = splitedAddresses[i].substring(0, splitedAddresses[i].length - 5)
        newAddress = `${newAddress + splitedAddresses[i]}\n`
      } else if (cutAline) {
      } else {
        const lineStart = splitedAddresses[i].substring(0, betweenLineIndex)
        const lineEnd = splitedAddresses[i].substring(betweenLineIndex + 5, splitedAddresses[i].length)
        splitedAddresses[i] = `${lineStart} ${lineEnd}`
        newAddress = `${newAddress + splitedAddresses[i]}\n`
      }
    } else if (!_.isEmpty(splitedAddresses[i])) {
      newAddress = `${newAddress + splitedAddresses[i]}\n`
    }
  }
  return newAddress
}

export function convertAddressToInlineAddress(
  inpAddr: IAddress | IQuickAddress | IMap<IAddress> | IMap<IQuickAddress>,
  options?: IConvertAddressToInlineAddressOptions
): string | null {
  if (_.isNil(inpAddr)) {
    return null
  }

  // const addr: IAddress | IQuickAddress = Map.isMap(inpAddr) ? inpAddr.toJS() : inpAddr
  const addr: IGenericAddress = Map.isMap(inpAddr) ? inpAddr.toJS() : inpAddr

  if (_.isEmpty(addr)) {
    return null
  }
  const opts = _.isNil(options) ? {} : options
  const { replacedName, withoutName } = opts

  const building_number = 'building_number' in addr && addr.building_number ? addr.building_number : null
  // @ts-ignore
  const address1 = addr.address1 || null
  // @ts-ignore
  const address3 = addr.address3 || null

  const address2 = addr.address2 || null
  const sub_district = addr.sub_district || null
  const district = addr.district || null
  const province = addr.province || null
  const postal_code = addr.postal_code || null
  const telephone = addr.telephone || null
  const email = addr.email || null
  const legal_entity_type = addr.legal_entity_type || 0
  const legal_entity_id = addr.legal_entity_id || null
  const branch_type = addr.branch_type || null
  const branch_number = addr.branch_number || null

  let txtFullAddress = ''
  let name = addr.name || null
  if (!_.isNil(replacedName) && _.isString(replacedName)) {
    name = replacedName
  }

  if (_.isBoolean(withoutName) && withoutName) {
    name = null
  }

  if (_.isString(name) && name.length > 0) {
    txtFullAddress = `${name}\n`
  }

  // if (building_number) {
  //   txtFullAddress = `${txtFullAddress}${building_number}`
  // }

  if (_.isString(address1) && address1.length > 0) {
    txtFullAddress = address1 ? `${txtFullAddress}${address1}` : txtFullAddress
  } else if (_.isString(address3) && address3.length > 0) {
    txtFullAddress = address3 ? `${txtFullAddress}${address3}` : txtFullAddress
  }

  txtFullAddress = address2 ? `${txtFullAddress} ${address2}` : txtFullAddress
  txtFullAddress = sub_district ? `${txtFullAddress} ${sub_district}` : txtFullAddress
  txtFullAddress = district ? `${txtFullAddress} ${district}` : txtFullAddress
  txtFullAddress = province ? `${txtFullAddress} ${province}` : txtFullAddress
  txtFullAddress = postal_code ? `${txtFullAddress}\n${postal_code}` : txtFullAddress
  txtFullAddress = telephone ? `${txtFullAddress}\nโทร. ${telephone}` : txtFullAddress
  txtFullAddress = email ? `${txtFullAddress}\nอีเมล ${email}` : txtFullAddress
  txtFullAddress =
    legal_entity_type > 0 && legal_entity_id
      ? `${txtFullAddress}\n${getLegalEntityLabel(legal_entity_type)} ${legal_entity_id}`
      : txtFullAddress

  if (branch_type === 'h') {
    txtFullAddress = `${txtFullAddress}\nสาขา สำนักงานใหญ่`
  }
  if (branch_type === 'b' && _.isString(branch_number) && branch_number.length > 0) {
    txtFullAddress = `${txtFullAddress}\nสาขา ${branch_number}`
  }

  return txtFullAddress
}

export function extractLegalEntityID(txtAddress: string, quickAddress: IQuickAddress): string {
  // console.log('quickAddress before legal check', quickAddress)
  // console.log('txtAddress', txtAddress)
  if (!quickAddress) {
    return txtAddress
  }
  // console.log("quickAddress['address1']", quickAddress['address1'])
  // console.log('quickAddress.address1', quickAddress.address1)
  // console.log('quickAddress.address2', quickAddress.address2)
  // console.log('quickAddress.address3', quickAddress.address3)
  const regLegalEntityIdArray = [
    // 0-1212-15435-12-3
    /\d{1}-\d{4}-\d{5}-\d{1,2}-\d{1,3}/g,
    // 0-12316-513-513-55
    /\d{1,}-\d{5}-\d{3}-\d{3}-\d{2}/g,
    // 0-12316-513513515
    /\d{1,}-\d{5}-\d{9,}/g,
    // 0-12316-513513-515
    /\d{1}-\d{5}-\d{6}-\d{3}/g,
    // 0121215435123
    /\d{13}/g,

    // sample:
    // อัจฉริยา เจริญศักดิ์ 66848744155 176/79 หมู่บ้านรัตนาวลัยหลักสี่ ประชาอุทิศ17 ถนน ประชาอุทิศ เขตดอนเมือง จังหวัดกรุงเทพมหานคร 10210 0-1212-15435-12-3
  ]

  // sample: Legal Entity
  // บริษัท ดรีมอินสไปร์ จำกัด (สำนักงานใหญ่)
  // 222/172 หมู่บ้านเออร์เบิน สาทร ถนนราชพฤกษ์ แขวงบางจาก เขตภาษีเจริญ กทม. 10160
  // เลขประจำตัวผู้เสียภาษี
  // 0105567199669

  const regLegalEntityIdTenDigitArray = [
    // 3-0332-9304-3
    /\d{1}-\d{4}-\d{4}-\d{1}/g,
    // 3033293043
    /\d{10}/g,
  ]

  const addressToCheckText = txtAddress
  // console.log('addressToCheckText', addressToCheckText)

  let legelEntityId: string = null
  let legelEntityIdFound = false
  let legalEntityIdMatchTenDigit = false

  for (let i = 0; i < regLegalEntityIdArray.length; i++) {
    const regUse = regLegalEntityIdArray[i]
    const reg = new RegExp(regUse)
    if (reg.test(addressToCheckText)) {
      legelEntityIdFound = true
      const checkedArray = addressToCheckText.match(regUse)
      // console.log('regLegalEntityId regUse', regUse)
      // console.log('regLegalEntityId checkedArray', checkedArray)
      if (checkedArray && checkedArray.length > 0) {
        // eslint-disable-next-line prefer-destructuring
        legelEntityId = checkedArray[0]
        break
      }
    }
  }

  // pKeng on 20250712: Do we need to check for 10 digit legal entity ID?
  // if (!legelEntityIdFound) {
  //   for (let i = 0; i < regLegalEntityIdTenDigitArray.length; i++) {
  //     const regUse = regLegalEntityIdTenDigitArray[i]
  //     const reg = new RegExp(regUse)
  //     if (reg.test(addressToCheckText)) {
  //       legelEntityIdFound = true
  //       const checkedArray = addressToCheckText.match(regUse)
  //       if (checkedArray && checkedArray.length > 0) {
  //         // eslint-disable-next-line prefer-destructuring
  //         legelEntityId = checkedArray[0]
  //         legalEntityIdMatchTenDigit = true
  //         break
  //       }
  //     }
  //   }
  // }

  // console.log('legelEntityIdFound', legelEntityIdFound)
  // console.log('legelEntityId', legelEntityId)
  if (legelEntityIdFound && legelEntityId) {
    quickAddress.legal_entity_id = legelEntityId.replace(/-/g, '')
    // quickAddress.legal_entity_type = 2
    if (txtAddress.includes('บริษัท') || txtAddress.includes('บจก')) {
      quickAddress.legal_entity_type = 11
      quickAddress.legal_entity_type_more_id = 11
    } else if (txtAddress.includes('ห้างหุ้นส่วน') || txtAddress.includes('หจก')) {
      quickAddress.legal_entity_type = 13
      quickAddress.legal_entity_type_more_id = 13
    } else if (txtAddress.includes('มหาชน')) {
      quickAddress.legal_entity_type = 12
      quickAddress.legal_entity_type_more_id = 12
    } else if (txtAddress.includes('จำกัด')) {
      quickAddress.legal_entity_type = 19
      quickAddress.legal_entity_type_more_id = 19
    } else {
      // quickAddress.legal_entity_type = 1
    }

    /*
    // const { name: nm } = quickAddress
    const a3 = txtAddress
    const nm = txtAddress
    if (
      // legalEntityIdMatchTenDigit ||
      // nm.includes('บริษัท') ||
      // nm.includes('บจก') ||
      // nm.includes('ห้างหุ้น') ||
      // nm.includes('จำกัด') ||
      // nm.includes('มหาชน') ||
      a3.includes('บริษัท') ||
      a3.includes('บจก') ||
      a3.includes('ห้างหุ้น') ||
      a3.includes('จำกัด') ||
      a3.includes('มหาชน')
    ) {
      quickAddress.legal_entity_type = 2
    } else {
      quickAddress.legal_entity_type = 1
    }

    if (
      txtAddress.includes('บริษัท') ||
      txtAddress.includes('บจก') ||
      txtAddress.includes('ห้างหุ้น') ||
      txtAddress.includes('จำกัด') ||
      txtAddress.includes('มหาชน')
    ) {
      quickAddress.legal_entity_type = 2
    } else {
      quickAddress.legal_entity_type = 1
      // quickAddress.legal_entity_type_more_id = 11
    }

    if (quickAddress?.legal_entity_type === 1) {
      quickAddress.legal_entity_type = 11
      quickAddress.legal_entity_type_more_id = 11
    }
    if (quickAddress?.legal_entity_type === 2) {
      if (nm.includes('บริษัท') || nm.includes('บจก')) {
        quickAddress.legal_entity_type = 11
        quickAddress.legal_entity_type_more_id = 11
      } else if (nm.includes('ห้างหุ้นส่วน') || nm.includes('หจก')) {
        quickAddress.legal_entity_type = 13
        quickAddress.legal_entity_type_more_id = 13
      } else if (nm.includes('มหาชน')) {
        quickAddress.legal_entity_type = 12
        quickAddress.legal_entity_type_more_id = 12
      } else {
        quickAddress.legal_entity_type = 19
        quickAddress.legal_entity_type_more_id = 19
      }
    }
      */

    txtAddress = txtAddress.replace(`${CONS.ADDRESS_LEGAL_ENTITY_LABELS[1]}:`, '')
    txtAddress = txtAddress.replace(`${CONS.ADDRESS_LEGAL_ENTITY_LABELS[2]}:`, '')
    txtAddress = txtAddress.replace(`เลขบัตรประชาชน:`, '')
    txtAddress = txtAddress.replace(`บัตรประชาชน:`, '')
    txtAddress = txtAddress.replace(`เลขผู้เสียภาษี:`, '')
    txtAddress = txtAddress.replace(`เลขบัตร:`, '')
    txtAddress = txtAddress.replace(CONS.ADDRESS_LEGAL_ENTITY_LABELS[1], '')
    txtAddress = txtAddress.replace(CONS.ADDRESS_LEGAL_ENTITY_LABELS[2], '')
    txtAddress = txtAddress.replace('เลขบัตรประชาชน', '')
    txtAddress = txtAddress.replace('บัตรประชาชน', '')
    txtAddress = txtAddress.replace('เลขผู้เสียภาษี', '')
    txtAddress = txtAddress.replace('เลขบัตร', '')
    txtAddress = txtAddress.replace(/\n/g, '')
    txtAddress = removeUnknownString(txtAddress.replace(legelEntityId, '').trim())
  }
  // console.log('quickAddress after legal check', quickAddress)
  // console.log('txtAddress after legal check', txtAddress)
  return txtAddress
}

// export function extractLegalEntityID(quickAddress: IQuickAddress): IQuickAddress {
//   console.log('quickAddress before legal check', quickAddress)

//   if (!quickAddress) {
//     return quickAddress
//   }
//   console.log("quickAddress['address1']", quickAddress['address1'])
//   console.log('quickAddress.address1', quickAddress.address1)
//   console.log('quickAddress.address2', quickAddress.address2)
//   console.log('quickAddress.address3', quickAddress.address3)
//   const regLegalEntityIdArray = [
//     // 0-1212-15435-12-3
//     /\d{1}-\d{4}-\d{5}-\d{1,2}-\d{1,3}/g,
//     // 0-12316-513-513-55
//     /\d{1,}-\d{5}-\d{3}-\d{3}-\d{2}/g,
//     // 0-12316-513513515
//     /\d{1,}-\d{5}-\d{9,}/g,
//     // 0-12316-513513-515
//     /\d{1}-\d{5}-\d{6}-\d{3}/g,
//     // 0121215435123
//     /\d{13}/g,

//     // sample:
//     // อัจฉริยา เจริญศักดิ์ 66848744155 176/79 หมู่บ้านรัตนาวลัยหลักสี่ ประชาอุทิศ17 ถนน ประชาอุทิศ เขตดอนเมือง จังหวัดกรุงเทพมหานคร 10210 0-1212-15435-12-3
//   ]

//   // sample: Legal Entity
//   // บริษัท ดรีมอินสไปร์ จำกัด (สำนักงานใหญ่)
//   // 222/172 หมู่บ้านเออร์เบิน สาทร ถนนราชพฤกษ์ แขวงบางจาก เขตภาษีเจริญ กทม. 10160
//   // เลขประจำตัวผู้เสียภาษี
//   // 0105567199669

//   const regLegalEntityIdTenDigitArray = [
//     // 3-0332-9304-3
//     /\d{1}-\d{4}-\d{4}-\d{1}/g,
//     // 3033293043
//     /\d{10}/g,
//   ]

//   const addressToCheckText = quickAddress.address1 + quickAddress.address2 + quickAddress.address3
//   let legelEntityId: string = null
//   let legelEntityIdFound = false
//   let legalEntityIdMatchTenDigit = false

//   for (let i = 0; i < regLegalEntityIdArray.length; i++) {
//     const regUse = regLegalEntityIdArray[i]
//     const reg = new RegExp(regUse)
//     if (reg.test(addressToCheckText)) {
//       legelEntityIdFound = true
//       const checkedArray = addressToCheckText.match(regUse)
//       // console.log('regLegalEntityId regUse', regUse)
//       // console.log('regLegalEntityId checkedArray', checkedArray)
//       if (checkedArray && checkedArray.length > 0) {
//         // eslint-disable-next-line prefer-destructuring
//         legelEntityId = checkedArray[0]
//         break
//       }
//     }
//   }

//   if (!legelEntityIdFound) {
//     for (let i = 0; i < regLegalEntityIdTenDigitArray.length; i++) {
//       const regUse = regLegalEntityIdTenDigitArray[i]
//       const reg = new RegExp(regUse)
//       if (reg.test(addressToCheckText)) {
//         legelEntityIdFound = true
//         const checkedArray = addressToCheckText.match(regUse)
//         if (checkedArray && checkedArray.length > 0) {
//           // eslint-disable-next-line prefer-destructuring
//           legelEntityId = checkedArray[0]
//           legalEntityIdMatchTenDigit = true
//           break
//         }
//       }
//     }
//   }
//   // console.log('legelEntityIdFound', legelEntityIdFound)
//   // console.log('legelEntityId', legelEntityId)
//   if (legelEntityIdFound && legelEntityId) {
//     quickAddress.legal_entity_id = legelEntityId.replace(/-/g, '')
//     const { name: nm, address1: a3 } = quickAddress
//     if (
//       legalEntityIdMatchTenDigit ||
//       nm.includes('บริษัท') ||
//       nm.includes('บจก') ||
//       nm.includes('ห้างหุ้น') ||
//       nm.includes('จำกัด') ||
//       nm.includes('มหาชน') ||
//       a3.includes('บริษัท') ||
//       a3.includes('บจก') ||
//       a3.includes('ห้างหุ้น') ||
//       a3.includes('จำกัด') ||
//       a3.includes('มหาชน')
//     ) {
//       quickAddress.legal_entity_type = 2
//     } else {
//       quickAddress.legal_entity_type = 1
//     }

//     if (quickAddress?.legal_entity_type === 1) {
//       quickAddress.legal_entity_type_more_id = 11
//     }
//     if (quickAddress?.legal_entity_type === 2) {
//       if (nm.includes('บริษัท') || nm.includes('บจก')) {
//         quickAddress.legal_entity_type_more_id = 11
//       } else if (nm.includes('ห้างหุ้นส่วน') || nm.includes('หจก')) {
//         quickAddress.legal_entity_type_more_id = 13
//       } else if (nm.includes('มหาชน')) {
//         quickAddress.legal_entity_type_more_id = 12
//       } else {
//         quickAddress.legal_entity_type_more_id = 19
//       }
//     }

//     quickAddress.address1 = quickAddress.address1.replace(`${CONS.ADDRESS_LEGAL_ENTITY_LABELS[1]}:`, '')
//     quickAddress.address1 = quickAddress.address1.replace(`${CONS.ADDRESS_LEGAL_ENTITY_LABELS[2]}:`, '')
//     quickAddress.address1 = quickAddress.address1.replace(`เลขบัตรประชาชน:`, '')
//     quickAddress.address1 = quickAddress.address1.replace(`บัตรประชาชน:`, '')
//     quickAddress.address1 = quickAddress.address1.replace(`เลขผู้เสียภาษี:`, '')
//     quickAddress.address1 = quickAddress.address1.replace(`เลขบัตร:`, '')
//     quickAddress.address1 = quickAddress.address1.replace(CONS.ADDRESS_LEGAL_ENTITY_LABELS[1], '')
//     quickAddress.address1 = quickAddress.address1.replace(CONS.ADDRESS_LEGAL_ENTITY_LABELS[2], '')
//     quickAddress.address1 = quickAddress.address1.replace('เลขบัตรประชาชน', '')
//     quickAddress.address1 = quickAddress.address1.replace('บัตรประชาชน', '')
//     quickAddress.address1 = quickAddress.address1.replace('เลขผู้เสียภาษี', '')
//     quickAddress.address1 = quickAddress.address1.replace('เลขบัตร', '')
//     quickAddress.address1 = quickAddress.address1.replace(/\n/g, '')
//     quickAddress.address1 = removeUnknownString(quickAddress.address1.replace(legelEntityId, '').trim())
//   }
//   console.log('quickAddress after legal check', quickAddress)
//   return quickAddress
// }

export function isLegalEntityIndividual(legal_entity_type: number) {
  const legalEntityTypeNymber = _.isNumber(legal_entity_type) ? legal_entity_type : +legal_entity_type
  // console.log('legalEntityTypeNymber  -- => ', legalEntityTypeNymber)
  return CONS.ADDRESS_LEGAL_ENTITY_TYPE_INDIVIDUAL_MORE_OPTIONS.findIndex((opt) => opt.id === legalEntityTypeNymber) >= 0
}

export function isLegalEntityCorporation(legal_entity_type: number) {
  const legalEntityTypeNymber = _.isNumber(legal_entity_type) ? legal_entity_type : +legal_entity_type
  return CONS.ADDRESS_LEGAL_ENTITY_TYPE_CORPORATION_MORE_OPTIONS.findIndex((opt) => opt.id === legalEntityTypeNymber) >= 0
}

export function getLegalEntityLabel(legal_entity_type: number) {
  if (isLegalEntityIndividual(_.isNumber(legal_entity_type) ? legal_entity_type : +legal_entity_type)) {
    return CONS.ADDRESS_LEGAL_ENTITY_LABELS[1]
  }
  if (isLegalEntityCorporation(_.isNumber(legal_entity_type) ? legal_entity_type : +legal_entity_type)) {
    return CONS.ADDRESS_LEGAL_ENTITY_LABELS[2]
  }
  return CONS.ADDRESS_LEGAL_ENTITY_LABELS[0]
}
